import { createContext, useContext } from 'react';

/**
 * Provides the Document that portal-using components inside this subtree
 * should target. Defaults to the main `document`; timeline subtrees that are
 * rendered into a detached popup window set this to the popup's document.
 *
 * Any component that calls `createPortal(..., document.body)` should read
 * from `usePortalHost()` and use `host.body` instead so it renders in
 * whichever window it's actually being displayed in.
 */
export const PortalHostContext = createContext<Document | null>(null);

export function usePortalHost(): Document {
  const ctx = useContext(PortalHostContext);
  if (typeof document === 'undefined') return ctx!; // SSR safety
  return ctx ?? document;
}
